module.exports = __webpack_public_path__ + "static/media/icon_2.3715a2b2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/pageTextCheck/icon_2.svg
// module id = 596
// module chunks = 0